import { useContext, useEffect } from "react";
import { useGetUpdateConnectionEntity } from "src/services/link/queries/update-connection";

import ThemeContext from "../../context";
import Context from "../context";

export const useGetUpdateConnection = () => {
	const { updateToken, restoreToken } = useContext(Context);
	const { state, actions } = useContext(ThemeContext);

	const { data, isError, isLoading } = useGetUpdateConnectionEntity(
		updateToken ? updateToken : restoreToken,
		state.authToken
	);

	useEffect(() => {
		if (data)
			actions.onSelectEntity({
				id: data.entity,
				name: data.entity,
				hasCredentials: data.hasCredentials,
				blocked: data.blocked
			});
	}, [data]);

	return { isError, isLoading };
};
